import { render, staticRenderFns } from "./ProductCategoryShow.vue?vue&type=template&id=76b8f333&"
import script from "./ProductCategoryShow.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports